import {MetaState} from 'types/State'
import {RootState} from 'store'
import brand from 'configs/brand'

export const augmentMetaState = (
  initialState: Partial<RootState>
): Partial<MetaState> => ({
  brand,
  // Allow tests to overwrite initial state
  ...(initialState?.meta || {})
})

export {default} from './slice'
